export default __webpack_public_path__ + "static/media/aboutCyberTeckAcademy.a02c8041.png";